export var MediaType;
(function (MediaType) {
    MediaType["IMAGE"] = "image";
    MediaType["VIDEO"] = "video";
    MediaType["AUDIO"] = "audio";
    MediaType["WEB"] = "web";
})(MediaType || (MediaType = {}));
export default MediaType;
//# sourceMappingURL=MediaType.js.map